/** Canonical group IDs shared by the web and voice runtimes. */
export enum GroupIds {
  APEX_LIVE = "59a52141-a5c7-43e4-b5fe-11bf74a225b0",
  APEX_LIVE_SANDBOX = "579fc606-25df-4ec3-b916-e12ce9ce24ee",
  AUTONOMY_LIVE = "4c1b47c3-eb1f-4e30-90e7-d3e36b0b16bb",
  AUTONOMY_LIVE_SANDBOX = "28bc6adf-5ef7-4618-966c-9bf114c9de68",
  BALANCE_HEALTH_LIVE = "f9125d70-411a-414e-9b80-5465152ed38e",
  BALANCE_HEALTH_LIVE_SANDBOX = "e85d79cb-1402-4e45-8b60-9b43ae8c3845",
  CONFLUENT_ALL_STAR_LIVE = "5a41eefb-69e9-4044-a570-0c4f5c9c39cd",
  CONFLUENT_ALL_STAR_LIVE_SANDBOX = "d032dd3c-0a47-4209-89b5-04f87b4a9034",
  CONVENIENT_MD_LIVE = "89e8c11d-9fde-4a0a-851a-4a0f1ede1f4d",
  CONVENIENT_MD_LIVE_SANDBOX = "f9d5a679-1d42-4ae2-9f5e-bbd51016fe75",
  COUG_LIVE = "c6aa944b-3c27-4a69-8afd-b753609bde7a",
  COUG_LIVE_SANDBOX = "98403e7c-9cb4-4e3f-9c84-9aad5edbdc7c",
  CRESCENTCARE_LIVE = "d48ff534-b81d-483f-94b8-24fa08ea00bc",
  CRESCENTCARE_LIVE_SANDBOX = "63e608a4-a478-470e-a0c0-3d776a27a55d",
  CVVC_LIVE = "552256ae-4bac-4099-98d2-9928961126e0",
  CVVC_LIVE_SANDBOX = "bcc9514a-9981-4cb7-bbc9-82b071eeb944",
  EMAIL_DLQ = "2d2e9e1c-0a9e-4ad8-9b76-bf5e5e67c0d1",
  ENT_PARTNERS_LIVE = "ed018461-8325-4332-93d5-62c74070188f",
  ENT_PARTNERS_LIVE_SANDBOX = "e333fb87-018e-43bb-863d-d06e84beab20",
  ENT_PARTNERS_MENT_LIVE = "7c59529e-2144-42f5-9686-2d33405c754d",
  ENT_PARTNERS_MENT_LIVE_SANDBOX = "477f1530-0196-407b-8910-f132f861b58a",
  ENT_PARTNERS_SCI_LIVE = "02a9e986-a7bb-4aab-a296-6e959d3128c1",
  ENT_PARTNERS_SCI_LIVE_SANDBOX = "bd2e4fa7-9a32-4370-abbb-19b0a54d87b0",
  ENT_PARTNERS_SUBOTO_LIVE = "7f9e39da-5fcb-4c3c-82f6-91b4fa437c1d",
  ENT_PARTNERS_SUBOTO_LIVE_SANDBOX = "34a19c79-0c59-4761-81ef-d2b39e9c182f",
  FCC_LIVE = "f2ae241e-603c-4687-9959-ae1f3a574fa4",
  FCC_LIVE_SANDBOX = "3f7e2d27-15a2-49ce-bab8-d102018fc766",
  HEADWAY_LIVE_SANDBOX = "79aaeaa0-075f-4a96-9334-5577200959a8",
  HVC_LIVE = "21a127bc-8d7e-47d6-ba8c-a61f0bd4e7eb",
  HVC_LIVE_SANDBOX = "d4257256-eea9-42b2-a53a-c75c2b3eeccf",
  INSIGHT_LIVE = "19b0c880-6e0a-4b4b-bc38-b2668e993c38",
  INSIGHT_LIVE_SANDBOX = "e43f2c7b-4d9e-4907-a96d-82979f5eb83f",
  MASSACHUSETTS_EAR_NOSE_AND_THROAT_ASSOCIATES_LIVE = "7c9bae8a-1dbf-484e-b1c0-fc73bcd9c873",
  MASSACHUSETTS_EAR_NOSE_AND_THROAT_ASSOCIATES_LIVE_SANDBOX = "830f4246-073b-44a0-aff2-8fc052c2cc72",
  MINDPATH_LIVE = "1c6ff7d1-7d01-4fe0-b454-9fa328458c1c",
  MINDPATH_LIVE_SANDBOX = "74d63c32-46e4-4f3f-a8ab-d87e471c5923",
  NIMBUS_LIVE = "c37e8d73-3dbf-4b9a-9f3e-138b611de24c",
  NIMBUS_LIVE_SANDBOX = "e03ec760-3cc1-4603-b65f-f9b862ed5b71",
  NIRA_LIVE = "9b6978a8-a8fe-4c99-bf5a-a2ce6161248c",
  NIRA_LIVE_SANDBOX = "ac2a1f74-487d-41a0-b212-1490d94f728e",
  NIRA_MSN_LIVE = "2049b8f0-c17b-4c8e-896b-56405faadf3d",
  NIRA_MSN_LIVE_SANDBOX = "32805f45-2fde-4f89-bbaa-1d527c325baa",
  NIRA_RMMSC_LIVE = "86a04ae5-caaf-4102-8505-02fb834b45a6",
  NIRA_RMMSC_LIVE_SANDBOX = "69766670-ca5e-4fae-8980-1e12d4f7a487",
  NVISION_EWEI_TORRANCE_LIVE = "9b4d2729-cc87-4bd5-a545-ef6f23e102c6",
  NVISION_EWEI_TORRANCE_LIVE_SANDBOX = "0426cad6-7787-46d2-a9a0-11efe39c4c79",
  PACESETTER_LIVE = "d6a311e2-c90c-4ff9-a006-b1af88846d04",
  PACESETTER_LIVE_SANDBOX = "8fa5bfea-5082-41cb-9524-4a000d80fb35",
  PA_CENTRAL_REGION_LIVE = "07da111b-d86f-416c-b3df-dd877457f49a",
  PA_CENTRAL_REGION_LIVE_SANDBOX = "7ab61571-8ed4-4259-bf7f-e3de2d26363f",
  PA_EAST_REGION_LIVE = "f39879cd-fcc4-496e-b808-cfc2e6117527",
  PA_EAST_REGION_LIVE_SANDBOX = "5f0d77ad-2c96-4f7c-86a9-f93cc8c2adf0",
  PINNACLE_MEDICAL_GROUP_LIVE = "d4b6f3f2-8a3e-47c5-a2d7-bdfda2d3c501",
  PINNACLE_MEDICAL_GROUP_LIVE_SANDBOX = "8f59b61d-91d8-4bc3-b91c-13dcf1ff915e",
  PPCP_LIVE = "6c91d591-7fdf-46e1-80bc-5fac73c66e94",
  PPCP_LIVE_SANDBOX = "0987cb15-1755-42e5-887d-19f0951d4921",
  QOROS_CFCG_LIVE = "3b22cbaf-2d49-40b8-8ae3-a49a2cbb666d",
  QOROS_CFCG_LIVE_SANDBOX = "0e639ef6-f479-4759-816a-8122532f568f",
  QOROS_LIVE = "ba1c3056-fad5-462b-9d05-c4b8b91bd41e",
  QOROS_LIVE_SANDBOX = "c26cca15-72b3-4988-ad37-1ac39370c7cc",
  SIENT_LIVE = "981f4b79-1348-49eb-8873-8f5e5ec5fc22",
  SIENT_LIVE_SANDBOX = "f4385415-8b2e-4c98-a390-a33a19f1f37e",
  SPORTORTHO_LIVE = "5e841fcb-ab0f-424d-be91-b4138e7563f7",
  SPORTORTHO_LIVE_SANDBOX = "0c6438f9-049a-451c-b1ef-1a96dc732325",
  STRIDECARE_LIVE = "6e08ff02-cb51-41b0-aeb5-fd8b9e8a20aa",
  STRIDECARE_LIVE_SANDBOX = "70489908-a817-4a7f-9c02-f97495b7a19c",
  TRICITY_LIVE = "f0eef1e1-d57d-41b4-ad49-f657d874ea89",
  TRICITY_LIVE_SANDBOX = "96e944f1-cd10-4ab2-b799-0b50690bfc7b",
  TEXAS_HEART_SOUTH_HEART_LIVE = "425f83dd-8b89-424f-8a7b-0ed0ad046ad3",
  TEXAS_HEART_SOUTH_HEART_LIVE_SANDBOX = "49c24ff1-cb02-4cb5-8e93-894ee001fb2f",
  TPR_BILTMORE_LIVE = "a770f915-b23d-4b3d-8f92-76bb186d4b98",
  TPR_BILTMORE_LIVE_SANDBOX = "6ada5df6-9348-434b-981e-9abd0f95fcc9",
  UNITED_VEIN_AND_VASCULAR_CENTERS_LIVE = "1a0d64cc-62a1-4fa1-8a2e-b3f9f2124561",
  UNITED_VEIN_AND_VASCULAR_CENTERS_LIVE_SANDBOX = "e8b38af6-3e60-4b40-ae6a-c10dc9a697aa",
  UPPERLINE_GEORGIA_LIVE = "8bab885a-339d-46af-ae77-6491b32125e5",
  UPPERLINE_GEORGIA_LIVE_SANDBOX = "4f5c0cf8-5b73-4a75-88d6-4121648d7279",
  UPPERLINE_INDIANA_LIVE = "3f220096-6e27-414e-8688-308049c6c3a3",
  UPPERLINE_INDIANA_LIVE_SANDBOX = "5b37e43e-11cf-4a55-bc9b-8d4c1b7dbfb6",
  UPPERLINE_FLORIDA_LIVE = "3c1626db-19b8-4c91-b3b3-81a6797a7e8b",
  UPPERLINE_FLORIDA_LIVE_SANDBOX = "d6fb10b6-96b6-4b68-b8fc-7253457a4128",
  UPPERLINE_TENNESSEE_LIVE = "3020a222-e3c0-45dd-9694-19f0d9ea3812",
  UPPERLINE_TENNESSEE_LIVE_SANDBOX = "0434ee93-af40-4280-b27f-d01f8dcf4a39",
  UPSTREAM_REHABILITATION_LIVE_SANDBOX = "2cdc6be3-be10-4c1f-bfc0-9dd3d9d29069",
  US_UROLOGY_PARTNERS_LIVE = "2f450c4e-e5c3-46f2-ae50-92dcb92a2d58",
  US_UROLOGY_PARTNERS_LIVE_SANDBOX = "497e8bbf-682b-4691-a0e4-c5f7d6c2a67c",
  USHV_CCOH_LIVE = "e34360e5-79a0-4fc7-bf96-74fc2cbcd562",
  USHV_CCOH_LIVE_SANDBOX = "613c2cda-b57d-411a-829d-40d6c0a0c280",
  USHV_FORTWORTH_LIVE = "d42653b2-c6cc-4f14-8326-1c3917f1cf25",
  USHV_FORTWORTH_LIVE_SANDBOX = "adb055e9-dc5f-4aff-827c-e21259eb71d1",
  USHV_HEARTLAND_LIVE = "595f0be2-60c4-4579-819e-f43e95a1df76",
  USHV_HEARTLAND_LIVE_SANDBOX = "f4464c70-a7b9-4145-8f9f-cc7e94bbea03",
  USHV_HEARTPLACE_LIVE = "eb922daf-4fdc-43b3-88dc-e8ec5f795a7d",
  USHV_HEARTPLACE_LIVE_SANDBOX = "1fa70383-e938-4c97-a702-f46651f33832",
  USHV_MCA_LIVE = "e618b319-1abe-480d-b7c0-33b4720cb527",
  USHV_MCA_LIVE_SANDBOX = "5def7b98-8e73-479d-9c7c-804109cc29e9",
  USHV_MKC_LIVE = "ad535d83-c803-40ea-86c6-fa6922cd2d9c",
  USHV_MKC_LIVE_SANDBOX = "8ef3134c-399a-41e8-9fca-b0a6536980c4",
  USHV_ORION_LIVE = "19287160-6c31-4aca-8e4c-650378e98159",
  USHV_ORION_LIVE_SANDBOX = "5af18e53-349a-4f25-a4a8-adfc5e83f1ca",
  USHV_PIMA_LIVE = "8be9abd2-92d3-4f3e-8268-5e57025f8295",
  USHV_PIMA_LIVE_SANDBOX = "941783e9-ff92-4f48-99c2-439088df8a92",
  USRC_LIVE = "eb772339-6e78-4318-ac0e-05c16b447235",
  USRC_LIVE_SANDBOX = "4186de6f-4f52-47b7-8242-caff6820bb27",
  USRC_CPS_AK_LIVE = "6cd92cb8-d88f-453c-9aae-dcfd41b0679a",
  USRC_CPS_AK_LIVE_SANDBOX = "b7a61da7-17d6-48fb-a713-f4d6000498bc",
  USRC_CPS_CO_LIVE = "115aa345-1ba8-496e-b563-26ed2a11a8c7",
  USRC_CPS_CO_LIVE_SANDBOX = "a88688c5-aaac-4b49-9451-45a7398ad3b5",
  VALERIE_HEALTH_DEV = "a8519747-7191-4142-8ba2-a37a77d329af",
  VALERIE_HEALTH_LIVE = "7f964a44-f1e5-4f59-94a2-c9e2058e7c9a",
  VALERIE_HEALTH_LIVE_SANDBOX = "483052a4-72da-4792-94b3-9c9f8048f0ea",
  VALERIE_HEALTH_TRAINING = "9be8b219-feff-48a7-b018-47a50733031d",
  VPS_LIVE = "6d4861f0-d03e-4e81-8561-52d3f9f01163",
  VPS_LIVE_SANDBOX = "87bb03ee-3fc4-405a-9a43-37fd4e2935c6",
}
